var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widgets orange-line",style:({
  position: 'absolute',
  left: _vm.val.left + 'px',
  top: _vm.val.top + 'px',
  width: _vm.val.width + 'px',
  minHeight: _vm.val.height + 'px',
  zIndex: _vm.val.style.zIndex,
  fontSize: _vm.val.style.FontSize + 'pt',
  textAlign: _vm.val.style.Alignment,
  fontWeight: _vm.val.style.Bold ? 'bold' : 'normal'
})},[_c('div',{style:({ borderLeft: _vm.val.style.FontSize + 'px ' + _vm.val.style.type, height: _vm.val.height + 'px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }